import useSocketReconnect from '../../utils/useSocketReconnect';
import { useEffect, useState } from "react";
import { v4 as uuidv4 } from 'uuid';

import Select from 'react-select';
import ChooseEvent from "./ChooseEvent";
import SubgroupSetter from "./SubgroupSetter";

import './notifications.css';
import './NotificationLog.css';
import LastHourNotifications from "./LastHourNotifications";
import { fetchAPI } from "../../utils/utils";
import { can } from "../../utils/permissions";
import NotificationGroupManager from "./groups/NotificationGroupManager";
import NotificationLog from "./NotificationLog";
import ScheduledNotifications from "./ScheduledNotifications";
import Pressable from "../other/Pressable";
import UserInfo from "../login/UserInfo";
import HeaderTabs from "../interface/HeaderTabs";
import moment from "moment";
import { getCastellerNameWithMote, getCastellerShortName } from "../../utils/castellerName";
import { NOTIFICATION_TITLE_MAX_LENGTH } from "./notificationLimits";

function MockupNotification({ ...props }) {
    const { title, body } = props;

    return (
        <div style={{
            width: '100%',
            backgroundColor: '#fff',
            borderRadius: 14,
            boxShadow: '0 2px 12px rgba(0,0,0,0.12)',
            padding: '12px 14px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            gap: 12,
            boxSizing: 'border-box',
        }}>
            <img
                style={{
                    width: 44,
                    height: 44,
                    borderRadius: 10,
                    flexShrink: 0,
                }}
                src="/aleta-icon.png"
                alt="Aleta"
            />
            <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: '#1a1a1a',
                    lineHeight: 1.3,
                    marginBottom: 2,
                }}>
                    {title}
                </div>
                <div style={{
                    fontSize: 13,
                    color: '#4a4a4a',
                    lineHeight: 1.4,
                    wordBreak: 'break-word',
                    whiteSpace: 'pre-line',
                }}>
                    {body}
                </div>
            </div>
        </div>
    );
}

function ChooseSubgroup({ socket, subgroupName, setSubgroupName, event, forms }) {
    const thereIsAForm = event && event in forms;
    const subgroups_values = !thereIsAForm ? ['No confirmat', 'Vinc', 'No vinc'] : ['No confirmat', 'Vinc', 'No vinc', 'Formulari no respost']
    const subgroups_labels = !thereIsAForm ? ['No confirmats', 'Venen', 'No venen'] : ['No confirmats', 'Venen', 'No venen', 'Formulari no respost']

    return (
        <div className="notifications-subgroup-buttons">
            {
                subgroups_values.map((subgroup, i) => (
                    <button
                        key={subgroup}
                        className={`notifications-subgroup-btn ${subgroup === subgroupName ? 'notifications-subgroup-btn-active' : ''}`}
                        onClick={() => setSubgroupName(subgroup)}
                    >
                        {subgroups_labels[i]}
                    </button>
                ))
            }
        </div>
    );
}

function DateTimeSelector({ scheduledDateTime, setScheduledDateTime, isScheduling, setIsScheduling, defaultDateTime }) {
  useEffect(() => {
    if (defaultDateTime && !scheduledDateTime) {
      setScheduledDateTime(defaultDateTime);
    }
  }, [defaultDateTime]);

  return (
    <div className="notification-input-group">
      <div className="schedule-options">
        <button
          className={`schedule-btn ${!isScheduling ? 'active' : ''}`}
          onClick={() => {
            setIsScheduling(false);
            setScheduledDateTime(null);
          }}
        >
          <i className="fas fa-bolt"></i>
          Enviar ara
        </button>
        <button
          className={`schedule-btn ${isScheduling ? 'active' : ''}`}
          onClick={() => {
            setIsScheduling(true);
            if (defaultDateTime && !scheduledDateTime) {
              setScheduledDateTime(defaultDateTime);
            }
          }}
        >
          <i className="fas fa-clock"></i>
          Programar per després
        </button>
      </div>
      {isScheduling ? (
        <input
          type="datetime-local"
          className="schedule-datetime-input"
          value={scheduledDateTime || ''}
          onChange={(e) => setScheduledDateTime(e.target.value)}
        />
      ) : null}
    </div>
  );
}

function NotificationsDashboard({ socket, userId, castellersInfo, setCastellersInfo, userInfo, ...props }) {
    useSocketReconnect(socket, () => {
        socket.emit('.get_all_forms');
    });

    const [title, setTitle] = useState('')
    const [body, setBody] = useState('')

    const [userIds, setUserIds] = useState([])
    const [notificationGroups, setNotificationGroups] = useState([])

    const [selectedEvent, setSelectedEvent] = useState(null)
    const [selectedDay, setSelectedDay] = useState(null)

    const [events, setEvents] = useState([])

    const [subgroupName, setSubgroupName] = useState('No confirmat')

    const [notificationsState, setNotificationsState] = useState('none')
    const [notificationsCounter, setNotificationsCounter] = useState(0)

    const withNotis = userIds.filter(user => user.color !== 'red').length
    const withoutNotis = userIds.filter(user => user.color === 'red').length

    const [forms, setForms] = useState({});

    const format_text = (text, id) => {
        const nom = id in castellersInfo ? castellersInfo[id].nom : ''
        const cognom = id in castellersInfo ? castellersInfo[id].cognom : ''
        const sobrenom = id in castellersInfo ?
            castellersInfo[id].mote ? castellersInfo[id].mote :
            castellersInfo[id].nom ? castellersInfo[id].nom :
            ''
        : ''

        return text
            .replaceAll(' {nom}', nom !== '' ? ` ${nom}` : '')
            .replaceAll('{nom}', nom !== '' ? nom : '')
            .replaceAll(' {cognom}', cognom !== '' ? ` ${cognom}` : '')
            .replaceAll('{cognom}', cognom !== '' ? cognom : '')
            .replaceAll(' {sobrenom}', sobrenom !== '' ? ` ${sobrenom}` : '')
            .replaceAll('{sobrenom}', sobrenom !== '' ? sobrenom : '')
    }

    const valid_tags = ['{nom}', '{cognom}', '{sobrenom}']

    const check_tags = (text) => {
        const wordswithtags = text.split(' ')
            .filter(word => word.length > 0)
            .filter(word => word.includes("{") && word.includes("}"))

        const invalid_tags = wordswithtags
            .filter(word => valid_tags.every(vtag => !word.includes(vtag)))

        if (invalid_tags.length > 0) {
            alert(
                'Cuidado! Has posat les següents etiquetes que no existeixen:\n\n' +
                invalid_tags.join(', ') +
                '\n\nLes etiquetes existents són:\n\n' +
                valid_tags.join(', ')
            )

            return false;
        }

        return true;
    }

    const [scheduledDateTime, setScheduledDateTime] = useState(null);
    const [isScheduling, setIsScheduling] = useState(false);
    const [defaultDateTime, setDefaultDateTime] = useState(null);
    const [activeTab, setActiveTab] = useState('enviar');
    const [selectionMode, setSelectionMode] = useState('event'); // 'event' or 'group'

    const notificationTabs = ['enviar', 'programades', 'ultima-hora', 'registre', 'grups'];

    const getTabFromPath = () => {
        const path = window.location.pathname;
        const parts = path.split('/');
        const lastPart = parts[parts.length - 1];

        if (notificationTabs.includes(lastPart)) {
            return lastPart;
        }

        return 'enviar';
    };

    const notifica_users = () => {
        if (!check_tags(title)) return;
        if (!check_tags(body)) return;

        if (notificationsState !== 'none') {
            const continuar = window.confirm('Estàs segur que vols enviar un altre cop la mateixa notificació?')
            if (!continuar) return;
        }

        const notification_id = uuidv4();

        const message = {
            title: title !== '' ? title : defaultTitle,
            body: body !== '' ? body : defaultBody,
            data: {
                selectedDay: selectedDay,
                notification_id: notification_id
            },
            notification_id: notification_id,
            author: userId,
            userIds: userIds.map(user => user.value)
        };

        if (isScheduling && scheduledDateTime) {
            const scheduledTime = new Date(scheduledDateTime).toISOString();

            setNotificationsState('scheduling');
            socket.emit(
                '.schedule_notification',
                scheduledTime,
                message,
                userIds.map(user => user.value),
                response => {
                    if (response?.success) {
                        setNotificationsState('scheduled');
                    } else {
                        setNotificationsState('none');
                        alert(response?.error || 'No s\'ha pogut programar la notificació.');
                    }
                }
            );
        } else {
            userIds.forEach(target =>  
                socket.emit('.send_notification_to_user',
                    target.value,
                    {
                        ...message,
                        title: format_text(message.title, target.value),
                        body: format_text(message.body, target.value),
                    }
                )
            );

            // Notifications' animation
            setNotificationsCounter(0);
            setNotificationsState('loading');
            userIds.forEach((userId, i) => setTimeout(() => setNotificationsCounter(prev => prev + 1), i*100));
            setTimeout(() => setNotificationsState('done'), userIds.length*100);
        }
    };

    useEffect(() => {
        document.title = `Notificacions - Aleta`;
    }, []);

    useEffect(() => {
        const tabFromPath = getTabFromPath();
        setActiveTab(tabFromPath);

        const handlePopState = () => {
            setActiveTab(getTabFromPath());
        };

        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, []);

    useEffect(() => {
        fetchAPI('/notification_groups', setNotificationGroups);
    }, []);

    useEffect(() => {
        socket.emit('.get_all_forms');
        const onAllForms = data => setForms(data);
        socket.on('.all_forms', onAllForms);

        return () => {
            socket.off('.all_forms', onAllForms);
        }
    }, []);

    useEffect(() => {
        setNotificationsState('none')
    }, [userIds, title, body, selectedEvent])

    const changeTab = (tab) => {
        setActiveTab(tab);

        const currentPath = window.location.pathname;
        const basePath = currentPath.replace(/\/(ultima-hora|enviar|programades|registre|grups)$/, '');
        const normalizedBasePath = basePath.endsWith('/') ? basePath : `${basePath}/`;

        window.history.pushState({ tab }, '', `${normalizedBasePath}${tab}`);
    };

    const optionStyles = {
        multiValue: (styles, { data, isDisabled }) => ({ ...styles, color: data.color }),
        multiValueLabel: (styles, { data, isDisabled }) => ({ ...styles, color: data.color }),
        option: (styles, { data, isDisabled }) => ({ ...styles, color: data.color })
    }

    const displayName = info => (info.canalla ? '👶 ' : '') + getCastellerNameWithMote(info)

    const user_names = Object.values(castellersInfo)
        .map(info => ({
            value: info.id,
            label: displayName(info),
            color: info.has_notifications ? 'black' : 'red'
        }))

    const names_where = condition => Object.values(castellersInfo)
        .filter(condition)
        .map(info => ({
            value: info.id,
            label: displayName(info),
            color: info.has_notifications ? 'black' : 'red'
        }))

    const tecnica_names = names_where(info => info.es_tecnica)

    // Groups that already come from each person's profile in Gestió
    const profile_groups = [
        { key: 'junta', label: 'Junta', icon: 'fa-briefcase', names: names_where(info => info.es_junta) },
        { key: 'musics', label: 'Músics', icon: 'fa-drum', names: names_where(info => info.music) },
        { key: 'canalla', label: 'Canalla', icon: 'fa-child', names: names_where(info => info.canalla) },
    ].filter(group => group.names.length > 0)

    const grups = Object.fromEntries(
        (Array.isArray(notificationGroups) ? notificationGroups : [])
            .filter(group => group.name)
            .map(group => {
                const ids = new Set((group.ids || []).map(id => parseInt(id)))
                return [group.name, names_where(info => ids.has(parseInt(info.id)))]
            })
    )

    const hasRecipients = userIds.length > 0;
    const hasActiveRecipients = userIds.filter(u => u.color !== 'red').length > 0;

    const howManyDaysFromToday = (dateString) => {
        const date = new Date(dateString);
        const today = new Date();
        const diffTime = Math.abs(date - today);
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
        return diffDays;
    }

    const formatDaysFromToday = (dateString) => {
        const days = howManyDaysFromToday(dateString);
        if (days === 0) return 'avui';
        if (days === 1) return 'demà';
        return `en ${days} dies`;
    }

    const formatTimeDifference = (dateString) => {
        const date = new Date(dateString);
        const now = new Date();
        const diffTime = Math.abs(date - now);
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
        const diffHours = Math.floor((diffTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const diffMinutes = Math.floor((diffTime % (1000 * 60 * 60)) / (1000 * 60));
        const diffSeconds = Math.floor((diffTime % (1000 * 60)) / 1000);
        
        let result = 'd\'aquí ';
        if (diffDays === 1) {
            result += '1 dia, ';
        } else if (diffDays > 1) {
            result += `${diffDays} dies, `;
        }
        if (diffHours === 1) {
            result += '1 hora, ';
        } else if (diffHours > 1) {
            result += `${diffHours} hores, `;
        }
        if (diffMinutes === 1) {
            result += '1 minut';
        } else if (diffMinutes > 1) {
            result += `${diffMinutes} minuts`;
        }
        if (diffMinutes < 2) {
            if (diffMinutes > 0) {
                result += ', ';
            }

            if (diffSeconds === 0) {
                result += '0 segons';
            } else if (diffSeconds === 1) {
                result += '1 segon';
            } else if (diffSeconds > 1) {
                result += `${diffSeconds} segons`;
            }
        }
        return result.trim().replace(/,\s*$/, '');
    }
    
    const defaultTitle = selectedEvent ? '{nom}, comptem amb tu?' : 'Títol que sortirà a la part superior de la notificació'
    const defaultBody = selectedEvent ? `{nom}, no ens has dit si vens a ${events.filter(ev => ev.id === selectedEvent)[0].title} (${formatDaysFromToday(events.filter(ev => ev.id === selectedEvent)[0]['data-esperada-inici'])}). Comunica'ns-ho ara!` : 'Missatge que surt en lletra petita'

    const displayNameFromId = id => castellersInfo[id] ?
        getCastellerShortName(castellersInfo[id]) :
        ''

    const formatRecentDate = (dateString) => {
        const diff = Math.abs(moment() - moment(dateString));
        const diffSeconds = Math.floor(diff / 1000);
        if (diffSeconds < 60) return `Fa ${diffSeconds}s`;
        const diffMinutes = Math.floor(diffSeconds / 60);
        if (diffMinutes < 60) return `Fa ${diffMinutes}min`;
        const diffHours = Math.floor(diffMinutes / 60);
        if (diffHours < 24) return `Fa ${diffHours}h`;
        return moment(dateString).format('DD/MM HH:mm');
    }

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);

        if (urlParams.get('titol') || urlParams.get('missatge')) {
            setTitle(decodeURIComponent(urlParams.get('titol')))
            setBody(decodeURIComponent(urlParams.get('missatge')))
        }
    }, [
        
    ])

    const [loopIndex, setLoopIndex] = useState(0)
    const [recentNotifications, setRecentNotifications] = useState([])

    useEffect(() => {
      if (selectedEvent) {
        const eventInfo = events.find(event => event.id === selectedEvent);
        if (eventInfo) {
          setDefaultDateTime(moment(eventInfo['data-esperada-inici']).format('YYYY-MM-DDTHH:mm'));
        }
      } else {
        setDefaultDateTime(null);
      }
    }, [selectedEvent, events]);

    useEffect(() => {
      setScheduledDateTime(null);
      setIsScheduling(false);
    }, [selectedEvent]);

    // Fetch recent notifications for the "send" tab
    useEffect(() => {
        // Load the 5 most recent notification IDs (merx_order_ filtered in backend)
        fetchAPI('/notification_ids?limit=5', ids => {
            // Load details for each notification group
            Promise.all(
                ids.map(notificationId =>
                    new Promise(resolve => {
                        fetchAPI(`/notifications/${encodeURIComponent(notificationId)}`, data => {
                            resolve(data);
                        });
                    })
                )
            ).then(groups => {
                setRecentNotifications(groups.filter(g => g && g.length > 0));
            });
        });
    }, [notificationsState === 'done']);

    const renderLastHourSection = () => (
        <>
            <h1>Notificacions d'última hora</h1>
            <p>Si un casteller canvia la seva assistència abans de tantes hores de l'assaig, se us enviarà una notificació a tècnica. Tria per cada casteller a quin responsable de tècnica se li envia.</p>

            <LastHourNotifications
                socket={socket}
                tecnica_names={tecnica_names}
                user_names={user_names}
                castellersInfo={castellersInfo}
            />
        </>
    );

    const renderSendNotificationSection = () => (
        <div className="notification-section">
            <h1 style={{ marginBottom: 24 }}>Envia una notificació</h1>

            {/* Step 1: Select Recipients */}
            <div className={`notification-card ${hasRecipients ? 'active' : ''}`}>
                <div className="notification-card-header">
                    <span className={`notification-step-badge ${hasRecipients ? 'completed' : ''}`}>1</span>
                    <div>
                        <h3 className="notification-card-title">Selecciona els destinataris</h3>
                    </div>
                </div>

                {/* Selection mode tabs */}
                <div className="selection-mode-tabs">
                    <button
                        className={`selection-mode-tab ${selectionMode === 'event' ? 'active' : ''}`}
                        onClick={() => setSelectionMode('event')}
                    >
                        <i className="fas fa-calendar-alt"></i>
                        Per esdeveniment
                    </button>
                    <button
                        className={`selection-mode-tab ${selectionMode === 'group' ? 'active' : ''}`}
                        onClick={() => setSelectionMode('group')}
                    >
                        <i className="fas fa-users"></i>
                        Per grup
                    </button>
                </div>

                {/* Event-based selection */}
                {selectionMode === 'event' ? (
                    <div className="selection-mode-content">
                        <div className="notifications-event-selection-layout">
                            <div className="notifications-event-sidebar">
                                <ChooseEvent forms={forms} events={events} setEvents={setEvents} selectedEvent={selectedEvent} setSelectedEvent={setSelectedEvent} setSelectedDay={setSelectedDay} socket={socket} subgroupName={subgroupName} />
                            </div>
                            <div className="notifications-event-selection-content">
                                <ChooseSubgroup event={selectedEvent} forms={forms} subgroupName={subgroupName} setSubgroupName={setSubgroupName} />
                                <SubgroupSetter forms={forms} socket={socket} event={selectedEvent} selectUsers={setUserIds} subgroupName={subgroupName} setSubgroupName={setSubgroupName} />
                            </div>
                        </div>
                    </div>
                ) : null}

                {/* Group-based selection */}
                {selectionMode === 'group' ? (
                    <div className="selection-mode-content">
                        <div className="quick-groups-container">
                            <button className="quick-group-btn everyone" onClick={() => setUserIds(user_names)}>
                                <i className="fas fa-globe"></i> Tothom
                            </button>
                            <button className="quick-group-btn tecnica" onClick={() => setUserIds(tecnica_names)}>
                                <i className="fas fa-user-cog"></i> Tècnica
                            </button>
                            {profile_groups.map(group => (
                                <button key={group.key} className="quick-group-btn tecnica" onClick={() => setUserIds(group.names)}>
                                    <i className={`fas ${group.icon}`}></i> {group.label}
                                </button>
                            ))}
                            {Object.keys(grups).map(grup => (
                                <button key={grup} className="quick-group-btn custom" onClick={() => setUserIds(grups[grup])}>
                                    {grup}
                                </button>
                            ))}
                            <button
                                className="quick-group-btn"
                                style={{ border: '1px dashed #95a5a6', color: '#7f8c8d', backgroundColor: 'transparent' }}
                                onClick={() => changeTab('grups')}
                            >
                                <i className="fas fa-edit"></i> Editar grups
                            </button>
                        </div>
                    </div>
                ) : null}

                {/* Recipients selector - always visible for custom selection */}
                <div style={{ marginTop: 24, paddingTop: 20, borderTop: '1px solid #e5e9f2' }}>
                    {hasRecipients ? (
                        <div className="recipients-header">
                            <div className="recipients-count">
                                <span className="active-count">{userIds.filter(u => u.color !== 'red').length}</span>
                                <span>rebran la notificació</span>
                                {userIds.filter(u => u.color === 'red').length > 0 ? (
                                    <>
                                        <span style={{ color: '#95a5a6' }}>·</span>
                                        <span className="inactive-count">{userIds.filter(u => u.color === 'red').length}</span>
                                        <span>🔕 sense notificacions</span>
                                    </>
                                ) : null}
                            </div>
                            {userIds.filter(user => user.color === 'red').length > 0 ? (
                                <button
                                    className="clear-inactive-btn"
                                    onClick={() => setUserIds(userIds.filter(user => user.color !== 'red'))}
                                >
                                    Treure 🔕
                                </button>
                            ) : null}
                        </div>
                    ) : (
                        <div style={{ marginBottom: 12 }}>
                            <span style={{ fontSize: 14, color: '#7f8c8d' }}>Selecciona els destinataris manualment o tria un esdeveniment/grup</span>
                        </div>
                    )}
                    <Select
                        options={user_names}
                        isMulti
                        name="users"
                        className="basic-multi-select"
                        classNamePrefix="select"
                        value={userIds}
                        onChange={setUserIds}
                        styles={optionStyles}
                        placeholder="Cerca i selecciona castellers..."
                    />
                    <p className="recipients-help">
                        Els usuaris en <span style={{ color: '#e74c3c', fontWeight: 500 }}>vermell</span> no tenen l'Aleta instal·lada o les notificacions activades.
                    </p>
                </div>
            </div>

            {/* Step 2: Compose Message */}
            <div className={`notification-card ${(title || body) ? 'active' : ''}`}>
                <div className="notification-card-header">
                    <span className={`notification-step-badge ${(title || body) ? 'completed' : ''}`}>2</span>
                    <div>
                        <h3 className="notification-card-title">Escriu el missatge</h3>
                        <p className="notification-card-subtitle">Personalitza el títol i el contingut</p>
                    </div>
                </div>

                {/* Title input */}
                <div className="notification-input-group">
                    <div className="notification-input-label">
                        <span className="notification-input-label-text">Títol</span>
                        <button
                            className={`apply-suggestion-btn ${title !== '' ? 'hidden' : ''}`}
                            onClick={() => setTitle(defaultTitle)}
                        >
                            Aplicar proposta
                        </button>
                    </div>
                    <input
                        className="notification-input"
                        placeholder={selectedEvent ? defaultTitle : 'Títol de la notificació'}
                        name="title"
                        value={title}
                        maxLength={NOTIFICATION_TITLE_MAX_LENGTH}
                        onChange={ev => setTitle(ev.target.value)}
                    />
                    <p className="input-hint">
                        Pots usar {valid_tags.map((tag, i) => (
                            <span key={tag}>
                                <code className="tag clickable" onClick={() => setTitle(prev => prev + tag)}>{tag}</code>
                                {i < valid_tags.length - 2 ? ', ' : i === valid_tags.length - 2 ? ' o ' : ' '}
                            </span>
                        ))}per personalitzar
                    </p>
                </div>

                {/* Body input */}
                <div className="notification-input-group">
                    <div className="notification-input-label">
                        <span className="notification-input-label-text">Missatge</span>
                        <button
                            className={`apply-suggestion-btn ${body !== '' ? 'hidden' : ''}`}
                            onClick={() => setBody(defaultBody)}
                        >
                            Aplicar proposta
                        </button>
                    </div>
                    <textarea
                        className="notification-input notification-textarea"
                        placeholder={selectedEvent ? defaultBody : 'Escriu el missatge de la notificació...'}
                        name="body"
                        maxLength={256}
                        onChange={ev => setBody(ev.target.value)}
                        value={body}
                    />
                    <p className="input-hint">
                        Pots usar {valid_tags.map((tag, i) => (
                            <span key={tag}>
                                <code className="tag clickable" onClick={() => setBody(prev => prev + tag)}>{tag}</code>
                                {i < valid_tags.length - 2 ? ', ' : i === valid_tags.length - 2 ? ' o ' : ' '}
                            </span>
                        ))}per personalitzar
                    </p>
                </div>
            </div>

            {/* Step 3: Preview (only shown when there are recipients) */}
            {hasRecipients ? (
                <div className="notification-card">
                    <div className="notification-card-header">
                        <span className="notification-step-badge">3</span>
                        <div>
                            <h3 className="notification-card-title">Previsualització</h3>
                            <p className="notification-card-subtitle">Així es veurà la notificació</p>
                        </div>
                    </div>

                    <div className="preview-container">
                        <div className="preview-navigation">
                            <button
                                className="preview-nav-btn"
                                onClick={() => setLoopIndex(prev => (prev - 1 + userIds.length) % userIds.length)}
                            >
                                ← Anterior
                            </button>
                            <button
                                className="preview-nav-btn"
                                onClick={() => setLoopIndex(prev => (prev + 1) % userIds.length)}
                            >
                                Següent →
                            </button>
                        </div>
                        <MockupNotification
                            title={format_text(title || defaultTitle, userIds[loopIndex % userIds.length].value)}
                            body={format_text(body || defaultBody, userIds[loopIndex % userIds.length].value)}
                        />
                    </div>
                </div>
            ) : null}

            {/* Step 4: Schedule & Send */}
            <div className="notification-card">
                <div className="notification-card-header">
                    <span className="notification-step-badge">{hasRecipients ? '4' : '3'}</span>
                    <div>
                        <h3 className="notification-card-title">Envia la notificació</h3>
                        <p className="notification-card-subtitle">Ara o programa-la per més tard</p>
                    </div>
                </div>

                <DateTimeSelector
                    scheduledDateTime={scheduledDateTime}
                    setScheduledDateTime={setScheduledDateTime}
                    isScheduling={isScheduling}
                    setIsScheduling={setIsScheduling}
                    defaultDateTime={defaultDateTime}
                />

                <button
                    className="send-notification-btn primary"
                    onClick={notifica_users}
                    disabled={!hasActiveRecipients || (isScheduling && !scheduledDateTime)}
                >
                    {!hasRecipients ? (
                        <>Selecciona destinataris</>
                    ) : isScheduling && scheduledDateTime ? (
                        <>
                            <i className="fas fa-clock"></i>
                            Programar per {formatTimeDifference(scheduledDateTime)}
                        </>
                    ) : (
                        <>
                            <i className="fas fa-paper-plane"></i>
                            Enviar a {userIds.filter(u => u.color !== 'red').length} {userIds.filter(u => u.color !== 'red').length === 1 ? 'casteller' : 'castellers'}
                        </>
                    )}
                </button>
            </div>

            {/* Status feedback */}
            {notificationsState !== 'none' ? (
                <div className={`notification-status ${notificationsState === 'done' || notificationsState === 'scheduled' ? 'success' : ''}`}>
                    <h4>
                        {notificationsState === 'loading' ? 'Enviant notificacions...' : null}
                        {notificationsState === 'scheduling' ? 'Programant notificació...' : null}
                        {notificationsState === 'done' ? '✅ Notificacions enviades!' : null}
                        {notificationsState === 'scheduled' ? '✅ Notificació programada!' : null}
                    </h4>

                    {['loading', 'scheduling'].includes(notificationsState) ? <div className="loading">&nbsp;</div> : null}

                    {notificationsState === 'loading' ? <p>Enviant notificació a {notificationsCounter} de {userIds.length} castellers...</p> : null}
                    {notificationsState === 'scheduling' ? <p>Desant la notificació programada...</p> : null}
                    {(notificationsState === 'done' && withNotis >= 1) ? <p>Notificació enviada correctament a <strong>{withNotis}</strong> {withNotis === 1 ? 'casteller' : 'castellers'}.</p> : null}
                    {(notificationsState === 'done' && withoutNotis >= 1) ? <p style={{ color: '#7f8c8d' }}><strong>{withoutNotis}</strong> {withoutNotis === 1 ? 'casteller' : 'castellers'} no {withoutNotis === 1 ? 'té' : 'tenen'} l'app o les notificacions activades.</p> : null}
                    {notificationsState === 'scheduled' ? <p>Notificació programada per {new Date(scheduledDateTime).toLocaleString()}.</p> : null}
                </div>
            ) : null}

            {/* Recent notifications */}
            {recentNotifications.length > 0 ? (
                <div className="recent-notifications-section">
                    <div className="recent-notifications-header">
                        <h3>Últimes notificacions enviades</h3>
                        <button
                            className="view-all-btn"
                            onClick={() => changeTab('registre')}
                        >
                            Veure historial complet →
                        </button>
                    </div>
                    <div style={{ width: '100%', overflowX: 'auto' }}>
                        <table className="notifications-log recent-notifications-table">
                            <thead>
                                <tr>
                                    <th>Enviador</th>
                                    <th>Receptors</th>
                                    <th>Títol (exemple)</th>
                                    <th>Missatge (exemple)</th>
                                    <th>Data d'enviament</th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: '0.8rem' }}>
                                {recentNotifications.map(notifications => {
                                    const recipients = notifications.map(n => displayNameFromId(n.target)).filter(Boolean);
                                    const firstRecipients = recipients.slice(0, 4);
                                    const remainingCount = recipients.length - 4;
                                    return (
                                        <tr key={notifications[0].notification_id}>
                                            <td>{displayNameFromId(notifications[0].author)}</td>
                                            <td>
                                                {firstRecipients.join(', ')}
                                                {remainingCount > 0 ? (
                                                    <span style={{ color: 'blue' }}>{` i ${remainingCount} més`}</span>
                                                ) : null}
                                            </td>
                                            <td>{notifications[0].title}</td>
                                            <td style={{ whiteSpace: 'pre-line' }}>{notifications[0].body}</td>
                                            <td style={{ whiteSpace: 'nowrap' }}>{formatRecentDate(notifications[0].createdAt)}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            ) : null}
        </div>
    );

    const renderNotificationLogSection = () => (
        <NotificationLog
            userId={userId}
            castellersInfo={castellersInfo}
            notificationsState={notificationsState}
            socket={socket}
        />
    );

    const renderScheduledNotificationsSection = () => (
        <ScheduledNotifications
            socket={socket}
            castellersInfo={castellersInfo}
            user_names={user_names}
        />
    );

    const renderGroupsSection = () => (
        <>
            <h1>Grups de notificacions</h1>
            <p>Gestiona els grups de persones per enviar notificacions de manera ràpida.</p>
            {
                can(userInfo, 'MANAGE_NOTIFICATION_GROUPS') ? (
                    <NotificationGroupManager user_names={user_names} onGroupsChange={setNotificationGroups} />
                ) : (
                    <p>No tens permisos per gestionar grups de notificacions.</p>
                )
            }
        </>
    );

    const renderTabContent = () => {
        if (activeTab === 'enviar') {
            return renderSendNotificationSection();
        }

        if (activeTab === 'ultima-hora') {
            return renderLastHourSection();
        }

        if (activeTab === 'programades') {
            return renderScheduledNotificationsSection();
        }

        if (activeTab === 'registre') {
            return renderNotificationLogSection();
        }

        if (activeTab === 'grups') {
            return renderGroupsSection();
        }

        return null;
    };

    return (
        <>
            <div
                style={{ width: '90%', boxSizing: 'border-box' }}
            >
                <UserInfo userInfo={userInfo} castellersInfo={castellersInfo} userId={userId} socket={socket} {...props} />

                <HeaderTabs userInfo={userInfo} {...props} />

                <Pressable style={{ backgroundColor: '#eee' }} className="boto-back" href='/'>
                    ← Tornar a la pàgina principal
                </Pressable>

                <h1>Notificacions</h1>

                <div className="page-layout">
                    <div className="navigation-tabs">
                        <button
                            className={`tab-button ${activeTab === 'enviar' ? 'active' : ''}`}
                            onClick={() => changeTab('enviar')}
                        >
                            <i className="fas fa-paper-plane"></i> Envia notificació
                        </button>
                        <button
                            className={`tab-button ${activeTab === 'ultima-hora' ? 'active' : ''}`}
                            onClick={() => changeTab('ultima-hora')}
                        >
                            <i className="fas fa-bell"></i> Notis d'última hora
                        </button>
                        <button
                            className={`tab-button ${activeTab === 'programades' ? 'active' : ''}`}
                            onClick={() => changeTab('programades')}
                        >
                            <i className="fas fa-clock"></i> Programades
                        </button>
                        <button
                            className={`tab-button ${activeTab === 'registre' ? 'active' : ''}`}
                            onClick={() => changeTab('registre')}
                        >
                            <i className="fas fa-history"></i> Historial
                        </button>
                        <button
                            className={`tab-button ${activeTab === 'grups' ? 'active' : ''}`}
                            onClick={() => changeTab('grups')}
                        >
                            <i className="fas fa-users"></i> Grups
                        </button>
                    </div>

                    <div className="page-content">
                        {renderTabContent()}
                    </div>
                </div>

                <div style={{ marginTop: 50 }}>&nbsp;</div>
            </div>
        </>
    )
}

export default NotificationsDashboard;
